module.exports = __webpack_public_path__ + "img/migration-service-elegance.5dced94b.png";